/**
 * Premium Article Page - Igniton
 * Reading progress bar, Table of Contents, Back to Top
 */

(function () {
  'use strict';

  /* =========================================================================
     Reading Progress Bar
     ========================================================================= */
  class ReadingProgressBar {
    constructor() {
      this.fill = document.querySelector('.reading-progress-bar__fill');
      this.article = document.querySelector('.article-content-premium');
      if (!this.fill || !this.article) return;

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    onScroll() {
      const rect = this.article.getBoundingClientRect();
      const articleTop = rect.top + window.scrollY;
      const articleHeight = this.article.offsetHeight;
      const viewportHeight = window.innerHeight;
      const scrolled = window.scrollY - articleTop + viewportHeight * 0.3;
      const progress = Math.min(Math.max(scrolled / articleHeight, 0), 1);
      this.fill.style.transform = 'scaleX(' + progress + ')';
    }
  }

  /* =========================================================================
     Table of Contents
     ========================================================================= */
  class TableOfContents {
    constructor() {
      this.container = document.querySelector('.toc-premium');
      this.list = document.querySelector('.toc-premium__list');
      this.article = document.querySelector('.article-content-premium');
      if (!this.container || !this.list || !this.article) return;

      this.headings = this.article.querySelectorAll('h2, h3');

      if (this.headings.length < 3) {
        this.container.classList.add('toc-premium--hidden');
        // Also hide wrapper on desktop
        var wrapper = this.container.closest('.toc-premium-wrapper');
        if (wrapper) wrapper.style.display = 'none';
        return;
      }

      this.buildTOC();
      this.setupScrollSpy();
      this.setupSmoothScroll();
      this.setupMobileToggle();
    }

    buildTOC() {
      var fragment = document.createDocumentFragment();

      this.headings.forEach(function (heading, index) {
        var slug = 'section-' + index + '-' + heading.textContent
          .toLowerCase()
          .trim()
          .replace(/\s+/g, '-')
          .replace(/[^\w-]/g, '')
          .substring(0, 50);

        heading.id = slug;

        var li = document.createElement('li');
        var level = heading.tagName === 'H2' ? 'primary' : 'secondary';
        li.className = 'toc-premium__item toc-premium__item--' + level;

        var a = document.createElement('a');
        a.className = 'toc-premium__link';
        a.href = '#' + slug;
        a.textContent = heading.textContent;

        li.appendChild(a);
        fragment.appendChild(li);
      });

      this.list.appendChild(fragment);
    }

    setupScrollSpy() {
      var links = this.list.querySelectorAll('.toc-premium__link');
      var self = this;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            links.forEach(function (link) { link.classList.remove('active'); });
            var activeLink = self.list.querySelector('a[href="#' + entry.target.id + '"]');
            if (activeLink) activeLink.classList.add('active');
          }
        });
      }, {
        rootMargin: '-100px 0px -80% 0px'
      });

      this.headings.forEach(function (heading) {
        observer.observe(heading);
      });
    }

    setupSmoothScroll() {
      this.list.addEventListener('click', function (e) {
        var link = e.target.closest('.toc-premium__link');
        if (!link) return;

        e.preventDefault();
        var targetId = link.getAttribute('href').slice(1);
        var target = document.getElementById(targetId);
        if (!target) return;

        var offset = 100;
        var targetPos = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: targetPos, behavior: 'smooth' });
      });
    }

    setupMobileToggle() {
      var toggle = this.container.querySelector('.toc-premium__toggle');
      var container = this.container;
      if (!toggle) return;

      toggle.addEventListener('click', function () {
        var expanded = container.getAttribute('aria-expanded') === 'true';
        container.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      });
    }
  }

  /* =========================================================================
     Back to Top
     ========================================================================= */
  class BackToTop {
    constructor() {
      this.button = document.querySelector('.back-to-top-premium');
      if (!this.button) return;

      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.button.addEventListener('click', this.scrollToTop);
      this.onScroll();
    }

    onScroll() {
      if (window.scrollY > 500) {
        this.button.classList.add('visible');
      } else {
        this.button.classList.remove('visible');
      }
    }

    scrollToTop(e) {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  /* =========================================================================
     Initialize
     ========================================================================= */
  document.addEventListener('DOMContentLoaded', function () {
    new ReadingProgressBar();
    new TableOfContents();
    new BackToTop();
  });
})();
